import { AspectRatio, Flex, FlexProps, Skeleton, SkeletonText } from '@chakra-ui/react';
import { ReactElement, ReactNode } from 'react';

export interface CardLoaderProps extends FlexProps {
  image?: boolean;
  imageRatio?: number;
  header?: boolean;
  button?: boolean;
  lines?: number;
  children?: ReactNode;
}
const CardLoader = ({
  image,
  imageRatio = 1,
  header = true,
  lines = 3,
  button,
  children,
  ...rest
}: CardLoaderProps): ReactElement | null => (
  <Flex
    direction={'column'}
    w={'full'}
    gap={4}
    p={6}
    rounded={'xl'}
    boxShadow={'lg'}
    mb={6}
    {...rest}
  >
    {image ? (
      <AspectRatio w={'full'} ratio={imageRatio}>
        <Skeleton h={'full'} w={'full'} rounded={'lg'} className="image" />
      </AspectRatio>
    ) : null}
    {header ? <Skeleton h={'28px'} w={'60%'} className="header" /> : null}
    {lines ? (
      <SkeletonText
        noOfLines={lines}
        spacing={2}
        skeletonHeight={'18px'}
        w={'full'}
        className={'line'}
      />
    ) : null}
    {button ? (
      <Skeleton h={'36px'} w={'full'} maxW={'150px'} className="button" rounded={'36px'} />
    ) : null}
    {children}
  </Flex>
);

export default CardLoader;
